// WARNING: For POST requests, body is set to null by browsers.
jQuery(function ($) {
  $('#open-four').click(function () {
    $('#modalOverlay-four').show().addClass('modal-open');
  });

  $('#close-four').click(function () {
    var modal = $('#modalOverlay-four');
    modal.removeClass('modal-open');
    setTimeout(function () {
      modal.hide();
    }, 200);
  });
});

jQuery(function ($) {
  $('#open-2').click(function () {
    $('#modalOverlay2').show().addClass('modal-open');
  });

  $('#close-2').click(function () {
    var modal = $('#modalOverlay2');
    modal.removeClass('modal-open');
    setTimeout(function () {
      modal.hide();
    }, 200);
  });

  // presentation modal mobile slider

  $('#energy_toolbox_carousel_two').owlCarousel({
    loop: false,
    margin: 20,
    nav: false,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/0469/0165/7754/t/304/assets/prev-arrow.svg?v=1692170508" alt="" />',
      '<img src="https://cdn.shopify.com/s/files/1/0469/0165/7754/t/304/assets/next-arrow.svg?v=1692170507" alt="" />'
    ],
    dots: true,
    items: 1,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    touchDrag: true,
    mouseDrag: true,
    smartSpeed: 1000,
    center: true,
    responsive: {
      0: {
        items: 1.3,
        nav: false,
        dots: true
      },
      767: {
        items: 2,
        nav: false,
        dots: true
      },
      991: {
        items: 2.5,
        nav: false,
        dots: true
      }
    }
  });

  jQuery(document).mouseup(function (e) {
    var container = jQuery('.dtp-popup');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('[data-popup-close]').trigger('click');
      $("main").removeClass("div-go-lft");
      $("body").removeClass("hide-scroll");
    }
  });

  jQuery(document).mouseup(function (e) {
    var container = jQuery('.pop-menu');
    var excludeContainer = jQuery('#mobo-ftr-btn');
    var excludeModal = jQuery('#big-modal-box-mobo-sec');
    // if the target of the click isn't the container nor a descendant of the container
    if (
      !container.is(e.target) &&
      container.has(e.target).length === 0 &&
      !excludeContainer.is(e.target) &&
      excludeContainer.has(e.target).length === 0 &&
      !excludeModal.is(e.target) &&
      excludeModal.has(e.target).length === 0
    ) {
      //console.log('good');
      if ($('header').hasClass('add-overlay')) {
        $('#mobo-ftr-btn').trigger('click');
      }
    }
  });
});
